import React, { useContext, useEffect, useState } from 'react';
import range from 'lodash/range';
import styles from './WineLocModal.scss';
import blackWineImg from '../../images/regal/black-wine.png';
import redWineImg from '../../images/regal/red-wine.png';
import ekranImg from '../../images/regal/ekran.png';
import banerImg from '../../images/regal/baner.png';

export function CloseSvg() {
  return (
    <svg width="40" height="40" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11613 7.99992L2.55808 12.558L3.44196 13.4419L8.00002 8.88381L12.5581 13.4419L13.442 12.558L8.8839 7.99992L13.442 3.44187L12.5581 2.55798L8.00002 7.11604L3.44196 2.55798L2.55807 3.44187L7.11613 7.99992Z"
      />
    </svg>
  );
}

function BottleImg({ glow, style }: { glow: boolean; style: React.CSSProperties }) {
  if (glow) {
    return <img src={redWineImg} className={styles.bottleimg} alt="bottleimg" style={style} />;
  }
  return <img src={blackWineImg} className={styles.bottleimg} alt="bottleimg" style={style} />;
}

export default function WineLocModal({
  slotId,
  show,
  setShow,
  galleryFix,
}: {
  slotId: number;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  galleryFix?: boolean;
}) {
  const glowId = slotId;
  let modalStyle: React.CSSProperties = {};
  if (!show) {
    modalStyle = {
      display: 'none',
    };
  }
  const regal = [range(1, 36), range(36, 64), range(64, 99), range(99, 134)];

  let regalScreanStyle: React.CSSProperties = {};
  let bottleimgStyle: React.CSSProperties = {};
  let banerImgStyle: React.CSSProperties = {};
  if (galleryFix) {
    regalScreanStyle = {
      height: '98px',
      width: '147px',
    };
    bottleimgStyle = {
      height: '80px',
      width: '21px',
    };
    banerImgStyle = {
      height: '63px',
    };
  }

  return (
    <div className={styles.modal} style={modalStyle}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <span className={styles.close} aria-hidden="true" onClick={() => setShow(false)}>
            <CloseSvg />
          </span>
          <h2>Lokalizacja wina na regale</h2>
        </div>
        <div className={styles.modalBody}>
          <div>
            <div className={styles.regal}>
              <div className={styles.regalHeaderRow}>
                <img src={banerImg} className={styles.regalBaner} alt="baner" style={banerImgStyle} />
              </div>
              <div className={styles.regalRow}>
                <div className={styles.wineWrapper}>
                  {regal[0].map((v, pk) => {
                    return <BottleImg key={pk} glow={v == glowId} style={bottleimgStyle} />;
                  })}
                </div>
              </div>
              <div className={styles.regalRow}>
                <div className={styles.wineWrapper}>
                  {regal[1].map((v, pk) => {
                    return <BottleImg key={pk} glow={v == glowId} style={bottleimgStyle} />;
                  })}
                </div>
                <img src={ekranImg} className={styles.regalScrean} alt="ekran" style={regalScreanStyle} />
              </div>
              <div className={styles.regalRow}>
                {regal[2].map((v, pk) => {
                  return <BottleImg key={pk} glow={v == glowId} style={bottleimgStyle} />;
                })}
              </div>
              <div className={styles.regalRow}>
                {regal[3].map((v, pk) => {
                  return <BottleImg key={pk} glow={v == glowId} style={bottleimgStyle} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
